export default __webpack_public_path__ + "static/form-one-column-do-319730f70a751a4f6c3b601fd813178f001f1324340e80deed7452cf72e242e3.png";